module.exports = __webpack_public_path__ + "media/images/icon__arrow-right-7d6376fb36a385b3e0168cf070390032.png";